/**
 * Parse the major version of *desktop Google Chrome* from a user-agent string.
 *
 * Returns null for anything that is not desktop Google Chrome. That includes
 * the Chromium forks, which all carry a `Chrome/NNN` token for compatibility
 * even though it is not their own release number:
 *
 *   - Edge              `Edg/`
 *   - Opera             `OPR/`
 *   - Samsung Internet  `SamsungBrowser/`
 *   - Chrome on iOS     `CriOS/`  (WebKit, not Blink — the bug does not apply)
 *   - Chrome on Android  mobile; out of scope, matching the desktop-only gate
 *                        on the existing "please use Chrome" modal
 *
 * Matching `Chrome/` alone would misidentify all of the above, so the forks are
 * rejected before the version is read.
 *
 * @param {string} userAgent  typically navigator.userAgent
 * @returns {number|null} the major version, or null if not desktop Chrome
 */
export function chromeMajorVersion(userAgent) {
    if (typeof userAgent !== 'string' || userAgent === '') {
        return null;
    }

    // Chromium forks and non-desktop Chrome — all carry a `Chrome/` token.
    if (/Edg[A-Z]?\/|OPR\/|SamsungBrowser\/|CriOS\/|Android/i.test(userAgent)) {
        return null;
    }

    const match = /Chrome\/(\d+)\./.exec(userAgent);

    if (!match) {
        return null;
    }

    const major = parseInt(match[1], 10);

    return Number.isNaN(major) ? null : major;
}
